import { render, staticRenderFns } from "./Inherent.vue?vue&type=template&id=35b63bcb&scoped=true&"
import script from "./Inherent.vue?vue&type=script&lang=js&"
export * from "./Inherent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b63bcb",
  null
  
)

export default component.exports